import { Box, Typography } from '@mui/material';
import { landingContent, landingCtas } from '../landing-content';
import { landingPalette } from '../landing-theme';
import { LandingCtaButton } from './LandingCtaButton';
import { LandingEyebrow } from './LandingEyebrow';
import { SectionShell } from './SectionShell';

/** Closing conversion block. */
export function FinalCta() {
  const { finalCta } = landingContent;

  return (
    <SectionShell
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'flex-end' },
        justifyContent: 'space-between',
        gap: 5,
        py: { xs: 8, md: 12 },
        borderBottom: `1px solid ${landingPalette.line}`,
      }}
    >
      <Box>
        <LandingEyebrow>{finalCta.eyebrow}</LandingEyebrow>
        <Typography variant="h2" component="h2" sx={{ maxWidth: 720 }}>
          {finalCta.title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
        <LandingCtaButton cta={landingCtas.learnMore} variant="primary" />
        <LandingCtaButton cta={landingCtas.contactUs} variant="outline" />
      </Box>
    </SectionShell>
  );
}
